import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import zoopersLogo from '../../assets/logo_website.png';
import { navLinks } from '../../mock';

export default function Header({ onBook }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-lg border-b border-pink-100 shadow-[0_4px_20px_-12px_rgba(233,30,128,0.15)]' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="/" className="flex items-center">
            <img src={zoopersLogo} alt="Zoopers" className="h-9 md:h-11 w-auto object-contain" />
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-9">
            {navLinks.map(l => (
              <a key={l.label} href={l.href} className="text-[15px] font-medium text-slate-700 hover:text-[#E91E80] transition-colors">
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button onClick={onBook} className="hidden md:inline-flex zp-pill-btn text-sm">
              Book Now
            </button>
            <button
              onClick={() => setMenuOpen(o => !o)}
              className="lg:hidden p-2 rounded-full hover:bg-pink-50 text-[#E91E80]"
            >
              {menuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="lg:hidden pb-4 animate-fadeUp">
            <div className="flex flex-col gap-1 rounded-2xl border border-pink-100 bg-white p-3 shadow-lg">
              {navLinks.map(l => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setMenuOpen(false)}
                  className="px-4 py-2.5 rounded-xl text-slate-700 hover:bg-pink-50 hover:text-[#E91E80] font-medium"
                >
                  {l.label}
                </a>
              ))}
              <button onClick={() => { onBook(); setMenuOpen(false); }} className="mt-2 zp-pill-btn text-center text-sm">
                Book Now
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
